module.exports = __webpack_public_path__ + "static/media/languageIcon.0a24ea01.png";